function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
/* eslint-disable @typescript-eslint/dot-notation, @typescript-eslint/naming-convention, @typescript-eslint/no-var-requires, @typescript-eslint/prefer-for-of, block-scoped-var, id-length, no-bitwise, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, one-var, sort-vars */ (function(global, factory) {
    /* AMD */ if (typeof define === "function" && define.amd) define([
        "protobufjs/minimal"
    ], factory);
    else if (typeof require === "function" && typeof module === "object" && module && module.exports) module.exports = factory(require("protobufjs/minimal"));
})(this, function($protobuf) {
    "use strict";
    // Common aliases
    var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;
    // Exported root namespace
    var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});
    $root.kaggle = function() {
        /**
       * Namespace kaggle.
       * @exports kaggle
       * @namespace
       */ var kaggle = {};
        kaggle.analytics = function() {
            /**
           * Namespace analytics.
           * @memberof kaggle
           * @namespace
           */ var analytics = {};
            analytics.ClientAnalyticsEvent = function() {
                var ClientAnalyticsEvent = /**
               * Properties of a ClientAnalyticsEvent.
               * @memberof kaggle.analytics
               * @interface IClientAnalyticsEvent
               * @property {string|null} [eventCategory] ClientAnalyticsEvent eventCategory
               * @property {string|null} [eventType] ClientAnalyticsEvent eventType
               * @property {string|null} [eventTime] ClientAnalyticsEvent eventTime
               * @property {string|null} [eventDataJson] ClientAnalyticsEvent eventDataJson
               * @property {string|null} [eventPage] ClientAnalyticsEvent eventPage
               */ /**
               * Constructs a new ClientAnalyticsEvent.
               * @memberof kaggle.analytics
               * @classdesc Represents a ClientAnalyticsEvent.
               * @implements IClientAnalyticsEvent
               * @constructor
               * @param {kaggle.analytics.IClientAnalyticsEvent=} [properties] Properties to set
               */ function ClientAnalyticsEvent(properties) {
                    if (properties) {
                        for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
                    }
                };
                /**
               * ClientAnalyticsEvent eventCategory.
               * @member {string} eventCategory
               * @memberof kaggle.analytics.ClientAnalyticsEvent
               * @instance
               */ ClientAnalyticsEvent.prototype.eventCategory = "";
                /**
               * ClientAnalyticsEvent eventType.
               * @member {string} eventType
               * @memberof kaggle.analytics.ClientAnalyticsEvent
               * @instance
               */ ClientAnalyticsEvent.prototype.eventType = "";
                /**
               * ClientAnalyticsEvent eventTime.
               * @member {string} eventTime
               * @memberof kaggle.analytics.ClientAnalyticsEvent
               * @instance
               */ ClientAnalyticsEvent.prototype.eventTime = "";
                /**
               * ClientAnalyticsEvent eventDataJson.
               * @member {string} eventDataJson
               * @memberof kaggle.analytics.ClientAnalyticsEvent
               * @instance
               */ ClientAnalyticsEvent.prototype.eventDataJson = "";
                /**
               * ClientAnalyticsEvent eventPage.
               * @member {string} eventPage
               * @memberof kaggle.analytics.ClientAnalyticsEvent
               * @instance
               */ ClientAnalyticsEvent.prototype.eventPage = "";
                /**
               * Creates a new ClientAnalyticsEvent instance using the specified properties.
               * @function create
               * @memberof kaggle.analytics.ClientAnalyticsEvent
               * @static
               * @param {kaggle.analytics.IClientAnalyticsEvent=} [properties] Properties to set
               * @returns {kaggle.analytics.ClientAnalyticsEvent} ClientAnalyticsEvent instance
               */ ClientAnalyticsEvent.create = function create(properties) {
                    return new ClientAnalyticsEvent(properties);
                };
                /**
               * Encodes the specified ClientAnalyticsEvent message. Does not implicitly {@link kaggle.analytics.ClientAnalyticsEvent.verify|verify} messages.
               * @function encode
               * @memberof kaggle.analytics.ClientAnalyticsEvent
               * @static
               * @param {kaggle.analytics.IClientAnalyticsEvent} message ClientAnalyticsEvent message or plain object to encode
               * @param {$protobuf.Writer} [writer] Writer to encode to
               * @returns {$protobuf.Writer} Writer
               */ ClientAnalyticsEvent.encode = function encode(message, writer) {
                    if (!writer) writer = $Writer.create();
                    if (message.eventCategory != null && message.hasOwnProperty("eventCategory")) writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.eventCategory);
                    if (message.eventType != null && message.hasOwnProperty("eventType")) writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.eventType);
                    if (message.eventTime != null && message.hasOwnProperty("eventTime")) writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.eventTime);
                    if (message.eventDataJson != null && message.hasOwnProperty("eventDataJson")) writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.eventDataJson);
                    if (message.eventPage != null && message.hasOwnProperty("eventPage")) writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.eventPage);
                    return writer;
                };
                /**
               * Encodes the specified ClientAnalyticsEvent message, length delimited. Does not implicitly {@link kaggle.analytics.ClientAnalyticsEvent.verify|verify} messages.
               * @function encodeDelimited
               * @memberof kaggle.analytics.ClientAnalyticsEvent
               * @static
               * @param {kaggle.analytics.IClientAnalyticsEvent} message ClientAnalyticsEvent message or plain object to encode
               * @param {$protobuf.Writer} [writer] Writer to encode to
               * @returns {$protobuf.Writer} Writer
               */ ClientAnalyticsEvent.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
                /**
               * Decodes a ClientAnalyticsEvent message from the specified reader or buffer.
               * @function decode
               * @memberof kaggle.analytics.ClientAnalyticsEvent
               * @static
               * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
               * @param {number} [length] Message length if known beforehand
               * @returns {kaggle.analytics.ClientAnalyticsEvent} ClientAnalyticsEvent
               * @throws {Error} If the payload is not a reader or valid buffer
               * @throws {$protobuf.util.ProtocolError} If required fields are missing
               */ ClientAnalyticsEvent.decode = function decode(reader, length) {
                    if (!_instanceof(reader, $Reader)) reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.kaggle.analytics.ClientAnalyticsEvent();
                    while(reader.pos < end){
                        var tag = reader.uint32();
                        switch(tag >>> 3){
                            case 1:
                                message.eventCategory = reader.string();
                                break;
                            case 2:
                                message.eventType = reader.string();
                                break;
                            case 3:
                                message.eventTime = reader.string();
                                break;
                            case 4:
                                message.eventDataJson = reader.string();
                                break;
                            case 5:
                                message.eventPage = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                        }
                    }
                    return message;
                };
                /**
               * Decodes a ClientAnalyticsEvent message from the specified reader or buffer, length delimited.
               * @function decodeDelimited
               * @memberof kaggle.analytics.ClientAnalyticsEvent
               * @static
               * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
               * @returns {kaggle.analytics.ClientAnalyticsEvent} ClientAnalyticsEvent
               * @throws {Error} If the payload is not a reader or valid buffer
               * @throws {$protobuf.util.ProtocolError} If required fields are missing
               */ ClientAnalyticsEvent.decodeDelimited = function decodeDelimited(reader) {
                    if (!_instanceof(reader, $Reader)) reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
                /**
               * Verifies a ClientAnalyticsEvent message.
               * @function verify
               * @memberof kaggle.analytics.ClientAnalyticsEvent
               * @static
               * @param {Object.<string,*>} message Plain object to verify
               * @returns {string|null} `null` if valid, otherwise the reason why it is not
               */ ClientAnalyticsEvent.verify = function verify(message) {
                    if (typeof message !== "object" || message === null) return "object expected";
                    if (message.eventCategory != null && message.hasOwnProperty("eventCategory")) {
                        if (!$util.isString(message.eventCategory)) return "eventCategory: string expected";
                    }
                    if (message.eventType != null && message.hasOwnProperty("eventType")) {
                        if (!$util.isString(message.eventType)) return "eventType: string expected";
                    }
                    if (message.eventTime != null && message.hasOwnProperty("eventTime")) {
                        if (!$util.isString(message.eventTime)) return "eventTime: string expected";
                    }
                    if (message.eventDataJson != null && message.hasOwnProperty("eventDataJson")) {
                        if (!$util.isString(message.eventDataJson)) return "eventDataJson: string expected";
                    }
                    if (message.eventPage != null && message.hasOwnProperty("eventPage")) {
                        if (!$util.isString(message.eventPage)) return "eventPage: string expected";
                    }
                    return null;
                };
                /**
               * Creates a ClientAnalyticsEvent message from a plain object. Also converts values to their respective internal types.
               * @function fromObject
               * @memberof kaggle.analytics.ClientAnalyticsEvent
               * @static
               * @param {Object.<string,*>} object Plain object
               * @returns {kaggle.analytics.ClientAnalyticsEvent} ClientAnalyticsEvent
               */ ClientAnalyticsEvent.fromObject = function fromObject(object) {
                    if (_instanceof(object, $root.kaggle.analytics.ClientAnalyticsEvent)) return object;
                    var message = new $root.kaggle.analytics.ClientAnalyticsEvent();
                    if (object.eventCategory != null) message.eventCategory = String(object.eventCategory);
                    if (object.eventType != null) message.eventType = String(object.eventType);
                    if (object.eventTime != null) message.eventTime = String(object.eventTime);
                    if (object.eventDataJson != null) message.eventDataJson = String(object.eventDataJson);
                    if (object.eventPage != null) message.eventPage = String(object.eventPage);
                    return message;
                };
                /**
               * Creates a plain object from a ClientAnalyticsEvent message. Also converts values to other types if specified.
               * @function toObject
               * @memberof kaggle.analytics.ClientAnalyticsEvent
               * @static
               * @param {kaggle.analytics.ClientAnalyticsEvent} message ClientAnalyticsEvent
               * @param {$protobuf.IConversionOptions} [options] Conversion options
               * @returns {Object.<string,*>} Plain object
               */ ClientAnalyticsEvent.toObject = function toObject(message, options) {
                    if (!options) options = {};
                    var object = {};
                    if (options.defaults) {
                        object.eventCategory = "";
                        object.eventType = "";
                        object.eventTime = "";
                        object.eventDataJson = "";
                        object.eventPage = "";
                    }
                    if (message.eventCategory != null && message.hasOwnProperty("eventCategory")) object.eventCategory = message.eventCategory;
                    if (message.eventType != null && message.hasOwnProperty("eventType")) object.eventType = message.eventType;
                    if (message.eventTime != null && message.hasOwnProperty("eventTime")) object.eventTime = message.eventTime;
                    if (message.eventDataJson != null && message.hasOwnProperty("eventDataJson")) object.eventDataJson = message.eventDataJson;
                    if (message.eventPage != null && message.hasOwnProperty("eventPage")) object.eventPage = message.eventPage;
                    return object;
                };
                /**
               * Converts this ClientAnalyticsEvent to JSON.
               * @function toJSON
               * @memberof kaggle.analytics.ClientAnalyticsEvent
               * @instance
               * @returns {Object.<string,*>} JSON object
               */ ClientAnalyticsEvent.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
                return ClientAnalyticsEvent;
            }();
            analytics.SaveClientAnalyticsRequest = function() {
                var SaveClientAnalyticsRequest = /**
               * Properties of a SaveClientAnalyticsRequest.
               * @memberof kaggle.analytics
               * @interface ISaveClientAnalyticsRequest
               * @property {string|null} [url] SaveClientAnalyticsRequest url
               * @property {number|null} [userId] SaveClientAnalyticsRequest userId
               * @property {string|null} [kauh] SaveClientAnalyticsRequest kauh
               * @property {string|null} [session] SaveClientAnalyticsRequest session
               * @property {number|null} [timeZoneOffsetMinutes] SaveClientAnalyticsRequest timeZoneOffsetMinutes
               * @property {string|null} [referrer] SaveClientAnalyticsRequest referrer
               * @property {string|null} [token] SaveClientAnalyticsRequest token
               * @property {number|null} [performanceTier] SaveClientAnalyticsRequest performanceTier
               * @property {number|null} [competitionsTier] SaveClientAnalyticsRequest competitionsTier
               * @property {number|null} [kernelsTier] SaveClientAnalyticsRequest kernelsTier
               * @property {number|null} [discussionTier] SaveClientAnalyticsRequest discussionTier
               * @property {number|null} [windowWidthPixels] SaveClientAnalyticsRequest windowWidthPixels
               * @property {number|null} [windowHeightPixels] SaveClientAnalyticsRequest windowHeightPixels
               * @property {number|null} [screenWidthPixels] SaveClientAnalyticsRequest screenWidthPixels
               * @property {number|null} [screenHeightPixels] SaveClientAnalyticsRequest screenHeightPixels
               * @property {Array.<kaggle.analytics.IClientAnalyticsEvent>|null} [events] SaveClientAnalyticsRequest events
               * @property {string|null} [pageview] SaveClientAnalyticsRequest pageview
               * @property {string|null} [urlQueryString] SaveClientAnalyticsRequest urlQueryString
               */ /**
               * Constructs a new SaveClientAnalyticsRequest.
               * @memberof kaggle.analytics
               * @classdesc Represents a SaveClientAnalyticsRequest.
               * @implements ISaveClientAnalyticsRequest
               * @constructor
               * @param {kaggle.analytics.ISaveClientAnalyticsRequest=} [properties] Properties to set
               */ function SaveClientAnalyticsRequest(properties) {
                    this.events = [];
                    if (properties) {
                        for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
                    }
                };
                /**
               * SaveClientAnalyticsRequest url.
               * @member {string} url
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @instance
               */ SaveClientAnalyticsRequest.prototype.url = "";
                /**
               * SaveClientAnalyticsRequest userId.
               * @member {number} userId
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @instance
               */ SaveClientAnalyticsRequest.prototype.userId = 0;
                /**
               * SaveClientAnalyticsRequest kauh.
               * @member {string} kauh
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @instance
               */ SaveClientAnalyticsRequest.prototype.kauh = "";
                /**
               * SaveClientAnalyticsRequest session.
               * @member {string} session
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @instance
               */ SaveClientAnalyticsRequest.prototype.session = "";
                /**
               * SaveClientAnalyticsRequest timeZoneOffsetMinutes.
               * @member {number} timeZoneOffsetMinutes
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @instance
               */ SaveClientAnalyticsRequest.prototype.timeZoneOffsetMinutes = 0;
                /**
               * SaveClientAnalyticsRequest referrer.
               * @member {string} referrer
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @instance
               */ SaveClientAnalyticsRequest.prototype.referrer = "";
                /**
               * SaveClientAnalyticsRequest token.
               * @member {string} token
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @instance
               */ SaveClientAnalyticsRequest.prototype.token = "";
                /**
               * SaveClientAnalyticsRequest performanceTier.
               * @member {number} performanceTier
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @instance
               */ SaveClientAnalyticsRequest.prototype.performanceTier = 0;
                /**
               * SaveClientAnalyticsRequest competitionsTier.
               * @member {number} competitionsTier
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @instance
               */ SaveClientAnalyticsRequest.prototype.competitionsTier = 0;
                /**
               * SaveClientAnalyticsRequest kernelsTier.
               * @member {number} kernelsTier
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @instance
               */ SaveClientAnalyticsRequest.prototype.kernelsTier = 0;
                /**
               * SaveClientAnalyticsRequest discussionTier.
               * @member {number} discussionTier
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @instance
               */ SaveClientAnalyticsRequest.prototype.discussionTier = 0;
                /**
               * SaveClientAnalyticsRequest windowWidthPixels.
               * @member {number} windowWidthPixels
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @instance
               */ SaveClientAnalyticsRequest.prototype.windowWidthPixels = 0;
                /**
               * SaveClientAnalyticsRequest windowHeightPixels.
               * @member {number} windowHeightPixels
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @instance
               */ SaveClientAnalyticsRequest.prototype.windowHeightPixels = 0;
                /**
               * SaveClientAnalyticsRequest screenWidthPixels.
               * @member {number} screenWidthPixels
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @instance
               */ SaveClientAnalyticsRequest.prototype.screenWidthPixels = 0;
                /**
               * SaveClientAnalyticsRequest screenHeightPixels.
               * @member {number} screenHeightPixels
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @instance
               */ SaveClientAnalyticsRequest.prototype.screenHeightPixels = 0;
                /**
               * SaveClientAnalyticsRequest events.
               * @member {Array.<kaggle.analytics.IClientAnalyticsEvent>} events
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @instance
               */ SaveClientAnalyticsRequest.prototype.events = $util.emptyArray;
                /**
               * SaveClientAnalyticsRequest pageview.
               * @member {string} pageview
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @instance
               */ SaveClientAnalyticsRequest.prototype.pageview = "";
                /**
               * SaveClientAnalyticsRequest urlQueryString.
               * @member {string} urlQueryString
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @instance
               */ SaveClientAnalyticsRequest.prototype.urlQueryString = "";
                /**
               * Creates a new SaveClientAnalyticsRequest instance using the specified properties.
               * @function create
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @static
               * @param {kaggle.analytics.ISaveClientAnalyticsRequest=} [properties] Properties to set
               * @returns {kaggle.analytics.SaveClientAnalyticsRequest} SaveClientAnalyticsRequest instance
               */ SaveClientAnalyticsRequest.create = function create(properties) {
                    return new SaveClientAnalyticsRequest(properties);
                };
                /**
               * Encodes the specified SaveClientAnalyticsRequest message. Does not implicitly {@link kaggle.analytics.SaveClientAnalyticsRequest.verify|verify} messages.
               * @function encode
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @static
               * @param {kaggle.analytics.ISaveClientAnalyticsRequest} message SaveClientAnalyticsRequest message or plain object to encode
               * @param {$protobuf.Writer} [writer] Writer to encode to
               * @returns {$protobuf.Writer} Writer
               */ SaveClientAnalyticsRequest.encode = function encode(message, writer) {
                    if (!writer) writer = $Writer.create();
                    if (message.url != null && message.hasOwnProperty("url")) writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.url);
                    if (message.userId != null && message.hasOwnProperty("userId")) writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.userId);
                    if (message.kauh != null && message.hasOwnProperty("kauh")) writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.kauh);
                    if (message.session != null && message.hasOwnProperty("session")) writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.session);
                    if (message.timeZoneOffsetMinutes != null && message.hasOwnProperty("timeZoneOffsetMinutes")) writer.uint32(/* id 5, wireType 0 =*/ 40).int32(message.timeZoneOffsetMinutes);
                    if (message.referrer != null && message.hasOwnProperty("referrer")) writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.referrer);
                    if (message.token != null && message.hasOwnProperty("token")) writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.token);
                    if (message.performanceTier != null && message.hasOwnProperty("performanceTier")) writer.uint32(/* id 8, wireType 0 =*/ 64).int32(message.performanceTier);
                    if (message.competitionsTier != null && message.hasOwnProperty("competitionsTier")) writer.uint32(/* id 9, wireType 0 =*/ 72).int32(message.competitionsTier);
                    if (message.kernelsTier != null && message.hasOwnProperty("kernelsTier")) writer.uint32(/* id 10, wireType 0 =*/ 80).int32(message.kernelsTier);
                    if (message.discussionTier != null && message.hasOwnProperty("discussionTier")) writer.uint32(/* id 11, wireType 0 =*/ 88).int32(message.discussionTier);
                    if (message.windowWidthPixels != null && message.hasOwnProperty("windowWidthPixels")) writer.uint32(/* id 12, wireType 0 =*/ 96).int32(message.windowWidthPixels);
                    if (message.windowHeightPixels != null && message.hasOwnProperty("windowHeightPixels")) writer.uint32(/* id 13, wireType 0 =*/ 104).int32(message.windowHeightPixels);
                    if (message.screenWidthPixels != null && message.hasOwnProperty("screenWidthPixels")) writer.uint32(/* id 14, wireType 0 =*/ 112).int32(message.screenWidthPixels);
                    if (message.screenHeightPixels != null && message.hasOwnProperty("screenHeightPixels")) writer.uint32(/* id 15, wireType 0 =*/ 120).int32(message.screenHeightPixels);
                    if (message.events != null && message.events.length) for(var i = 0; i < message.events.length; ++i)$root.kaggle.analytics.ClientAnalyticsEvent.encode(message.events[i], writer.uint32(/* id 16, wireType 2 =*/ 130).fork()).ldelim();
                    if (message.pageview != null && message.hasOwnProperty("pageview")) writer.uint32(/* id 17, wireType 2 =*/ 138).string(message.pageview);
                    if (message.urlQueryString != null && message.hasOwnProperty("urlQueryString")) writer.uint32(/* id 18, wireType 2 =*/ 146).string(message.urlQueryString);
                    return writer;
                };
                /**
               * Encodes the specified SaveClientAnalyticsRequest message, length delimited. Does not implicitly {@link kaggle.analytics.SaveClientAnalyticsRequest.verify|verify} messages.
               * @function encodeDelimited
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @static
               * @param {kaggle.analytics.ISaveClientAnalyticsRequest} message SaveClientAnalyticsRequest message or plain object to encode
               * @param {$protobuf.Writer} [writer] Writer to encode to
               * @returns {$protobuf.Writer} Writer
               */ SaveClientAnalyticsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
                /**
               * Decodes a SaveClientAnalyticsRequest message from the specified reader or buffer.
               * @function decode
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @static
               * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
               * @param {number} [length] Message length if known beforehand
               * @returns {kaggle.analytics.SaveClientAnalyticsRequest} SaveClientAnalyticsRequest
               * @throws {Error} If the payload is not a reader or valid buffer
               * @throws {$protobuf.util.ProtocolError} If required fields are missing
               */ SaveClientAnalyticsRequest.decode = function decode(reader, length) {
                    if (!_instanceof(reader, $Reader)) reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.kaggle.analytics.SaveClientAnalyticsRequest();
                    while(reader.pos < end){
                        var tag = reader.uint32();
                        switch(tag >>> 3){
                            case 1:
                                message.url = reader.string();
                                break;
                            case 2:
                                message.userId = reader.int32();
                                break;
                            case 3:
                                message.kauh = reader.string();
                                break;
                            case 4:
                                message.session = reader.string();
                                break;
                            case 5:
                                message.timeZoneOffsetMinutes = reader.int32();
                                break;
                            case 6:
                                message.referrer = reader.string();
                                break;
                            case 7:
                                message.token = reader.string();
                                break;
                            case 8:
                                message.performanceTier = reader.int32();
                                break;
                            case 9:
                                message.competitionsTier = reader.int32();
                                break;
                            case 10:
                                message.kernelsTier = reader.int32();
                                break;
                            case 11:
                                message.discussionTier = reader.int32();
                                break;
                            case 12:
                                message.windowWidthPixels = reader.int32();
                                break;
                            case 13:
                                message.windowHeightPixels = reader.int32();
                                break;
                            case 14:
                                message.screenWidthPixels = reader.int32();
                                break;
                            case 15:
                                message.screenHeightPixels = reader.int32();
                                break;
                            case 16:
                                if (!(message.events && message.events.length)) message.events = [];
                                message.events.push($root.kaggle.analytics.ClientAnalyticsEvent.decode(reader, reader.uint32()));
                                break;
                            case 17:
                                message.pageview = reader.string();
                                break;
                            case 18:
                                message.urlQueryString = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                        }
                    }
                    return message;
                };
                /**
               * Decodes a SaveClientAnalyticsRequest message from the specified reader or buffer, length delimited.
               * @function decodeDelimited
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @static
               * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
               * @returns {kaggle.analytics.SaveClientAnalyticsRequest} SaveClientAnalyticsRequest
               * @throws {Error} If the payload is not a reader or valid buffer
               * @throws {$protobuf.util.ProtocolError} If required fields are missing
               */ SaveClientAnalyticsRequest.decodeDelimited = function decodeDelimited(reader) {
                    if (!_instanceof(reader, $Reader)) reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
                /**
               * Verifies a SaveClientAnalyticsRequest message.
               * @function verify
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @static
               * @param {Object.<string,*>} message Plain object to verify
               * @returns {string|null} `null` if valid, otherwise the reason why it is not
               */ SaveClientAnalyticsRequest.verify = function verify(message) {
                    if (typeof message !== "object" || message === null) return "object expected";
                    if (message.url != null && message.hasOwnProperty("url")) {
                        if (!$util.isString(message.url)) return "url: string expected";
                    }
                    if (message.userId != null && message.hasOwnProperty("userId")) {
                        if (!$util.isInteger(message.userId)) return "userId: integer expected";
                    }
                    if (message.kauh != null && message.hasOwnProperty("kauh")) {
                        if (!$util.isString(message.kauh)) return "kauh: string expected";
                    }
                    if (message.session != null && message.hasOwnProperty("session")) {
                        if (!$util.isString(message.session)) return "session: string expected";
                    }
                    if (message.timeZoneOffsetMinutes != null && message.hasOwnProperty("timeZoneOffsetMinutes")) {
                        if (!$util.isInteger(message.timeZoneOffsetMinutes)) return "timeZoneOffsetMinutes: integer expected";
                    }
                    if (message.referrer != null && message.hasOwnProperty("referrer")) {
                        if (!$util.isString(message.referrer)) return "referrer: string expected";
                    }
                    if (message.token != null && message.hasOwnProperty("token")) {
                        if (!$util.isString(message.token)) return "token: string expected";
                    }
                    if (message.performanceTier != null && message.hasOwnProperty("performanceTier")) {
                        if (!$util.isInteger(message.performanceTier)) return "performanceTier: integer expected";
                    }
                    if (message.competitionsTier != null && message.hasOwnProperty("competitionsTier")) {
                        if (!$util.isInteger(message.competitionsTier)) return "competitionsTier: integer expected";
                    }
                    if (message.kernelsTier != null && message.hasOwnProperty("kernelsTier")) {
                        if (!$util.isInteger(message.kernelsTier)) return "kernelsTier: integer expected";
                    }
                    if (message.discussionTier != null && message.hasOwnProperty("discussionTier")) {
                        if (!$util.isInteger(message.discussionTier)) return "discussionTier: integer expected";
                    }
                    if (message.windowWidthPixels != null && message.hasOwnProperty("windowWidthPixels")) {
                        if (!$util.isInteger(message.windowWidthPixels)) return "windowWidthPixels: integer expected";
                    }
                    if (message.windowHeightPixels != null && message.hasOwnProperty("windowHeightPixels")) {
                        if (!$util.isInteger(message.windowHeightPixels)) return "windowHeightPixels: integer expected";
                    }
                    if (message.screenWidthPixels != null && message.hasOwnProperty("screenWidthPixels")) {
                        if (!$util.isInteger(message.screenWidthPixels)) return "screenWidthPixels: integer expected";
                    }
                    if (message.screenHeightPixels != null && message.hasOwnProperty("screenHeightPixels")) {
                        if (!$util.isInteger(message.screenHeightPixels)) return "screenHeightPixels: integer expected";
                    }
                    if (message.events != null && message.hasOwnProperty("events")) {
                        if (!Array.isArray(message.events)) return "events: array expected";
                        for(var i = 0; i < message.events.length; ++i){
                            var error = $root.kaggle.analytics.ClientAnalyticsEvent.verify(message.events[i]);
                            if (error) return "events." + error;
                        }
                    }
                    if (message.pageview != null && message.hasOwnProperty("pageview")) {
                        if (!$util.isString(message.pageview)) return "pageview: string expected";
                    }
                    if (message.urlQueryString != null && message.hasOwnProperty("urlQueryString")) {
                        if (!$util.isString(message.urlQueryString)) return "urlQueryString: string expected";
                    }
                    return null;
                };
                /**
               * Creates a SaveClientAnalyticsRequest message from a plain object. Also converts values to their respective internal types.
               * @function fromObject
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @static
               * @param {Object.<string,*>} object Plain object
               * @returns {kaggle.analytics.SaveClientAnalyticsRequest} SaveClientAnalyticsRequest
               */ SaveClientAnalyticsRequest.fromObject = function fromObject(object) {
                    if (_instanceof(object, $root.kaggle.analytics.SaveClientAnalyticsRequest)) return object;
                    var message = new $root.kaggle.analytics.SaveClientAnalyticsRequest();
                    if (object.url != null) message.url = String(object.url);
                    if (object.userId != null) message.userId = object.userId | 0;
                    if (object.kauh != null) message.kauh = String(object.kauh);
                    if (object.session != null) message.session = String(object.session);
                    if (object.timeZoneOffsetMinutes != null) message.timeZoneOffsetMinutes = object.timeZoneOffsetMinutes | 0;
                    if (object.referrer != null) message.referrer = String(object.referrer);
                    if (object.token != null) message.token = String(object.token);
                    if (object.performanceTier != null) message.performanceTier = object.performanceTier | 0;
                    if (object.competitionsTier != null) message.competitionsTier = object.competitionsTier | 0;
                    if (object.kernelsTier != null) message.kernelsTier = object.kernelsTier | 0;
                    if (object.discussionTier != null) message.discussionTier = object.discussionTier | 0;
                    if (object.windowWidthPixels != null) message.windowWidthPixels = object.windowWidthPixels | 0;
                    if (object.windowHeightPixels != null) message.windowHeightPixels = object.windowHeightPixels | 0;
                    if (object.screenWidthPixels != null) message.screenWidthPixels = object.screenWidthPixels | 0;
                    if (object.screenHeightPixels != null) message.screenHeightPixels = object.screenHeightPixels | 0;
                    if (object.events) {
                        if (!Array.isArray(object.events)) throw TypeError(".kaggle.analytics.SaveClientAnalyticsRequest.events: array expected");
                        message.events = [];
                        for(var i = 0; i < object.events.length; ++i){
                            if (typeof object.events[i] !== "object") throw TypeError(".kaggle.analytics.SaveClientAnalyticsRequest.events: object expected");
                            message.events[i] = $root.kaggle.analytics.ClientAnalyticsEvent.fromObject(object.events[i]);
                        }
                    }
                    if (object.pageview != null) message.pageview = String(object.pageview);
                    if (object.urlQueryString != null) message.urlQueryString = String(object.urlQueryString);
                    return message;
                };
                /**
               * Creates a plain object from a SaveClientAnalyticsRequest message. Also converts values to other types if specified.
               * @function toObject
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @static
               * @param {kaggle.analytics.SaveClientAnalyticsRequest} message SaveClientAnalyticsRequest
               * @param {$protobuf.IConversionOptions} [options] Conversion options
               * @returns {Object.<string,*>} Plain object
               */ SaveClientAnalyticsRequest.toObject = function toObject(message, options) {
                    if (!options) options = {};
                    var object = {};
                    if (options.arrays || options.defaults) object.events = [];
                    if (options.defaults) {
                        object.url = "";
                        object.userId = 0;
                        object.kauh = "";
                        object.session = "";
                        object.timeZoneOffsetMinutes = 0;
                        object.referrer = "";
                        object.token = "";
                        object.performanceTier = 0;
                        object.competitionsTier = 0;
                        object.kernelsTier = 0;
                        object.discussionTier = 0;
                        object.windowWidthPixels = 0;
                        object.windowHeightPixels = 0;
                        object.screenWidthPixels = 0;
                        object.screenHeightPixels = 0;
                        object.pageview = "";
                        object.urlQueryString = "";
                    }
                    if (message.url != null && message.hasOwnProperty("url")) object.url = message.url;
                    if (message.userId != null && message.hasOwnProperty("userId")) object.userId = message.userId;
                    if (message.kauh != null && message.hasOwnProperty("kauh")) object.kauh = message.kauh;
                    if (message.session != null && message.hasOwnProperty("session")) object.session = message.session;
                    if (message.timeZoneOffsetMinutes != null && message.hasOwnProperty("timeZoneOffsetMinutes")) object.timeZoneOffsetMinutes = message.timeZoneOffsetMinutes;
                    if (message.referrer != null && message.hasOwnProperty("referrer")) object.referrer = message.referrer;
                    if (message.token != null && message.hasOwnProperty("token")) object.token = message.token;
                    if (message.performanceTier != null && message.hasOwnProperty("performanceTier")) object.performanceTier = message.performanceTier;
                    if (message.competitionsTier != null && message.hasOwnProperty("competitionsTier")) object.competitionsTier = message.competitionsTier;
                    if (message.kernelsTier != null && message.hasOwnProperty("kernelsTier")) object.kernelsTier = message.kernelsTier;
                    if (message.discussionTier != null && message.hasOwnProperty("discussionTier")) object.discussionTier = message.discussionTier;
                    if (message.windowWidthPixels != null && message.hasOwnProperty("windowWidthPixels")) object.windowWidthPixels = message.windowWidthPixels;
                    if (message.windowHeightPixels != null && message.hasOwnProperty("windowHeightPixels")) object.windowHeightPixels = message.windowHeightPixels;
                    if (message.screenWidthPixels != null && message.hasOwnProperty("screenWidthPixels")) object.screenWidthPixels = message.screenWidthPixels;
                    if (message.screenHeightPixels != null && message.hasOwnProperty("screenHeightPixels")) object.screenHeightPixels = message.screenHeightPixels;
                    if (message.events && message.events.length) {
                        object.events = [];
                        for(var j = 0; j < message.events.length; ++j)object.events[j] = $root.kaggle.analytics.ClientAnalyticsEvent.toObject(message.events[j], options);
                    }
                    if (message.pageview != null && message.hasOwnProperty("pageview")) object.pageview = message.pageview;
                    if (message.urlQueryString != null && message.hasOwnProperty("urlQueryString")) object.urlQueryString = message.urlQueryString;
                    return object;
                };
                /**
               * Converts this SaveClientAnalyticsRequest to JSON.
               * @function toJSON
               * @memberof kaggle.analytics.SaveClientAnalyticsRequest
               * @instance
               * @returns {Object.<string,*>} JSON object
               */ SaveClientAnalyticsRequest.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
                return SaveClientAnalyticsRequest;
            }();
            return analytics;
        }();
        return kaggle;
    }();
    return $root;
});
